import { Button, FormControl, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast, useAuth } from "@/comn/hooks";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APIS, SF_INTF_ORG_ENPO_MGMT, SG_INTF_ORG_ENPO_MGMT } from "./services/OsciIntfOrgEnpoMgmtService";

/*
 * Channel List Popup
 * !== 채널 목록 팝업 ==!
 */
export const OSCI0113007Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid } = usePage({ pgeUid: "osci0113007q" });
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal();
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const { callback } = props;

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0088" },
            { area: "comnCd", comnCd: "OSC0164" },
            { area: "comnCd", comnCd: "OSC0103" }, // 대상 유형 코드
            { area: "comnCd", comnCd: "OSC0110" }, // 채널 신청 진행상태 코드
            { area: "comnCd", comnCd: "OSC0101" }, // 활성화 여부 코드
            { area: "comnCd", comnCd: "OSC0109" }, // 송수신 유형 코드
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        intfOrgEnpoMgmtSrch: useForm({
            defaultSchema: SF_INTF_ORG_ENPO_MGMT,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        intfOrgEnpoMgmtList: useGrid({
            defaultSchema: SG_INTF_ORG_ENPO_MGMT,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get a list of channel. !== 채널 목록을 조회한다. ==!
        getIntfOrgEnpoList: useFetch({
            api: (page = grid.intfOrgEnpoMgmtList.page) => {
                return APIS.getIntfOrgEnpoList(
                    form.intfOrgEnpoMgmtSrch.getValues(),
                    page,
                    grid.intfOrgEnpoMgmtList.size,
                );
            },
            enabled: comnUtils.isEmpty(form.intfOrgEnpoMgmtSrch.errors),
            key: [grid.intfOrgEnpoMgmtList.page, grid.intfOrgEnpoMgmtList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.intfOrgEnpoMgmtSrch.getValues(),
                    page: grid.intfOrgEnpoMgmtList.page,
                    size: grid.intfOrgEnpoMgmtList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Search Button !== 검색버튼 ==!
        getIntfOrgEnpoList: (page: number = 0) => {
            form.intfOrgEnpoMgmtSrch.handleSubmit(
                () => {
                    grid.intfOrgEnpoMgmtList.setPage(page);
                    fetch.getIntfOrgEnpoList.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        onApplyBtnClick: (cell: any) => {
            if (!grid.intfOrgEnpoMgmtList.isChecked()) {
                modal.openModal({ content: "msg.osc.00197" }); // 등록대상을 선택하세요.
                return;
            }

            callback(grid.intfOrgEnpoMgmtList.getChecked());
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        grid.intfOrgEnpoMgmtList.setOption("checkbox", true);
        grid.intfOrgEnpoMgmtList.setOption("index", false);
    }, []);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoMgmtSrch.schema.sndrcvDvnCd}></Group.Control>
                            <Group.Control {...form.intfOrgEnpoMgmtSrch.schema.orgCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.intfOrgEnpoMgmtSrch.schema.orgEnpoId}></Group.Control>
                            <Group.Control {...form.intfOrgEnpoMgmtSrch.schema.orgEnpoNm}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role={"reset"}
                                onClick={() => {
                                    form.intfOrgEnpoMgmtSrch.reset();
                                    form.intfOrgEnpoMgmtSrch.setValues({
                                        sndrcvDvnCd: "",
                                        orgCd: "",
                                        orgEnpoId: "",
                                        orgEnpoNm: "",
                                        intfId: "",
                                        orgTin: "",
                                        govesbUseYn: "",
                                    });
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getIntfOrgEnpoList();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.intfOrgEnpoMgmtList.grid} data={fetch.getIntfOrgEnpoList.data?.intfOrgEnpoLst} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Right>
                    <Layout.Button role={"apply"} onClick={handler.onApplyBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
